export const blockIconsNavigationCheck = (
	<span className='material-symbols-outlined'>check</span>
);
